import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {RequestService} from '../request/request.service';

@Injectable()
export class SlackService {
  apiUrl = environment.apiRoot;

  constructor(private reqService: RequestService) { }

  postToLinaFrontendErrors(object) {
    const req = {
      url: this.apiUrl + 'Slack/LinaFrontendErrors',
      data: object,
      config: {
        waitForCompletion: false,
        successToast: false,
        errorToast: false,
        socketLoadingBar: false,
        disableControls: false
      }
    };

    return this.reqService.postRequest(req);
  }

}
